import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { queriesKeys } from '../queriesKeys'

export const useGetEarningById = (earningId: number) =>
  useQuery({
    enabled: !!earningId,
    queryFn: () => api.earnings.getEarningById(earningId),
    queryKey: queriesKeys.earnings.getEarningById(earningId),
  })
